import { Badge, Button, Input, cn } from "@devhop/ui";
import { SearchIcon, XIcon } from "lucide-react";

export type ExpenseCategoryStatusFilter = "all" | "active" | "inactive";

export type ExpenseCategoriesFilterState = {
  search: string;
  status: ExpenseCategoryStatusFilter;
};

type ExpenseCategoriesFilterProps = {
  filters: ExpenseCategoriesFilterState;
  onFiltersChange: (next: ExpenseCategoriesFilterState) => void;
  filteredCount: number;
  totalCount: number;
};

const STATUS_OPTIONS: {
  key: ExpenseCategoryStatusFilter;
  label: string;
}[] = [
  { key: "all", label: "ທັງໝົດ" },
  { key: "active", label: "ໃຊ້ງານ" },
  { key: "inactive", label: "ບໍ່ໃຊ້ງານ" },
];

export function ExpenseCategoriesFilter({
  filters,
  onFiltersChange,
  filteredCount,
  totalCount,
}: ExpenseCategoriesFilterProps) {
  const hasActiveFilters =
    filters.search.trim() !== "" || filters.status !== "all";

  return (
    <div className="flex flex-col gap-3 border-b px-4 py-4 sm:flex-row sm:items-center sm:justify-between">
      <div className="relative w-full sm:max-w-sm">
        <SearchIcon className="pointer-events-none absolute top-1/2 left-3 size-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          value={filters.search}
          onChange={(event) =>
            onFiltersChange({ ...filters, search: event.target.value })
          }
          placeholder="ຄົ້ນຫາລະຫັດ ຫຼື ຊື່ຫມວດ..."
          className="pl-9"
        />
      </div>

      <div className="flex flex-wrap items-center gap-2">
        <div className="flex flex-wrap gap-1.5">
          {STATUS_OPTIONS.map((option) => (
            <button
              key={option.key}
              type="button"
              onClick={() =>
                onFiltersChange({ ...filters, status: option.key })
              }
              className={cn(
                "rounded-md border px-2.5 py-1 text-xs transition-colors",
                filters.status === option.key
                  ? "border-primary bg-primary/5 font-medium text-foreground"
                  : "border-transparent bg-muted/50 text-muted-foreground hover:bg-muted",
              )}
            >
              {option.label}
            </button>
          ))}
        </div>

        <Badge variant="outline" className="tabular-nums">
          {filteredCount.toLocaleString("lo-LA")} /{" "}
          {totalCount.toLocaleString("lo-LA")}
        </Badge>

        {hasActiveFilters ? (
          <Button
            type="button"
            variant="ghost"
            size="sm"
            className="h-8 px-2"
            onClick={() =>
              onFiltersChange({ search: "", status: "all" })
            }
          >
            <XIcon className="mr-1 size-3.5" />
            ລ້າງ
          </Button>
        ) : null}
      </div>
    </div>
  );
}
